<mat-card class="cardT usuario-titulo">
  <span>Usuário</span>
  <span class="usuario-acoes">
    <button
      mat-icon-button
      type="button"
      matTooltip="Editar usuário"
      [class.usuario-acao--ativa]="!exibindoRegrasETokens"
      [disabled]="!exibindoRegrasETokens"
      (click)="exibirEdicao()">
      <mat-icon>edit</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Regras/Tokens"
      [class.usuario-acao--ativa]="exibindoRegrasETokens"
      [disabled]="exibindoRegrasETokens"
      (click)="exibirRegrasETokens()">
      <mat-icon>vpn_key</mat-icon>
    </button>
  </span>
</mat-card>
<form *ngIf="!subscription && !exibindoRegrasETokens" [formGroup]="editFormGroup" autocomplete="off">

  <div class="foto-perfil-edicao">
    <button type="button" mat-stroked-button (click)="abrirFotoPerfil()">
      <mat-icon>photo_camera</mat-icon>
      Alterar imagem de perfil
    </button>
    <button type="button" class="foto-perfil-preview" [class.foto-perfil-preview--carregando]="fotoPerfilDisponivel && !fotoPerfilCarregada" (click)="abrirFotoPerfil()" matTooltip="Alterar imagem de perfil">
      <img *ngIf="fotoPerfilDisponivel" [src]="'/api/Usuarios/' + idUsuario + '/FotoPerfil?v=' + fotoPerfilVersao" (load)="onCarregouFotoPerfil()" (error)="onErroFotoPerfil()" alt="Foto de perfil">
      <span *ngIf="!fotoPerfilDisponivel">{{ iniciaisUsuario() }}</span>
    </button>
  </div>

  <div class="form-fields">
    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>Nome</mat-label>
      <input type="text" matInput formControlName="noNomeCompleto" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>CPF</mat-label>
      <input type="text" matInput formControlName="noCpfj" readonly autocomplete="off"/>
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>E-mail</mat-label>
      <input type="email" matInput formControlName="noEmail" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>Celular</mat-label>
      <input type="text" matInput formControlName="nrCelular" mask="+00 (00) 00000-0000" autocomplete="off"/>
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline" *ngIf="exibeCamposEasyMob">
      <mat-label>EasyMob Chave</mat-label>
      <input type="text" matInput formControlName="noEasyMobChave" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline" *ngIf="exibeCamposEasyMob">
      <mat-label>EasyMob Usuário</mat-label>
      <input type="text" matInput formControlName="noEasyMobUsuario" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline" *ngIf="exibeCamposEasyMob">
      <mat-label>EasyMob Senha</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="noEasyMobSenha" autocomplete="new-password">
    </mat-form-field>
  </div>
  <div class="buttons">
    <button type="submit" color="primary" class="btn" mat-raised-button [disabled]="editFormGroup.invalid"
      (click)="onSalvar()"> Salvar </button>
    <button type="button" color="basic" class="btn" mat-raised-button routerLink="/usuarios"> Voltar </button>
  </div>
</form>

<div *ngIf="!subscription && exibindoRegrasETokens" class="usuario-acessos">
  <app-usuario-regras *ngIf="usuario" [usuario]="usuario"></app-usuario-regras>
  <app-usuario-tokens *ngIf="usuario" [usuario]="usuario"></app-usuario-tokens>
</div>

<div class="subscription" *ngIf="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando...</p>
  </div>
</div>
